import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-switcher',
  styleUrl: 'switcher.css',
  shadow: false,
})
export class Switcher {
  @Prop() threshold: string = "var(--measure)";
  @Prop() space: string = 'var(--s1)';

  render() {
    return (
      <div class="switcher" style={{'--space': this.space, '--threshold': this.threshold}}>
        <div>
          <slot />
        </div>
      </div>
    );
  }
}
